// extracted by mini-css-extract-plugin
export default {"container":"_2aSvJ7P9f5q8ngF1YHRH3L","label":"_1Hhkso0b5LbK7hj5Iqmcar"};